export const MembershipType = {
  primary: "Primary",
  regional: "Regional",
  multiple: "Multiple Primary",
  secondary: "Secondary",
} as const;

export const OfficeType = {
  main: "Main",
  additional: "Additional",
} as const;

export const ServiceType = {
  legal: "Legal Services",
  accounting: "Accounting",
  investmentBanking: "Investment Banking",
  other: "Other",
} as const;

export type MembershipTypeEnum = keyof typeof MembershipType;
export type OfficeTypeEnum = keyof typeof OfficeType;
export type ServiceTypeEnum = keyof typeof ServiceType;
